
<template>
  <v-app id="app">

    <AppNavigation  />
    <v-app-bar
      :clipped-left="$vuetify.breakpoint.lgAndUp"
      app
      color="blue darken-4"
      dark
      style="height: 60px"
      >
      
      <v-toolbar-title>
        <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
        {{title}}
      </v-toolbar-title>
      <div class="flex-grow-1"></div>
      
      <v-toolbar-items>

        <!-- <v-btn 
          text
          v-if="$store.state.isUserLoggedIn"
          @click="userDetails">
          <span>{{ this.$store.getters.NeedFullUser }}</span>
        </v-btn> -->

        <v-btn
          text
          v-if="$store.state.isUserLoggedIn"
          @click="companyDetails">
          <span>{{ this.$store.state.companyName }}</span>
        </v-btn>

        <v-btn
          text
          v-if="$store.state.isUserLoggedIn"
          @click="companyDetails2">
          <span>{{ this.$store.state.businessYear }}</span>
        </v-btn>
<!-- 
        <v-btn
          text
          v-if="$store.state.isUserLoggedIn"
          @click="langDetails">
          <span>{{ this.$store.state.language }}</span>
        </v-btn> -->

        <!-- <v-btn
          text
          v-if="!$store.state.isUserLoggedIn"
          @click="login">
          Login
        </v-btn> -->

        <!-- Brojcic uz ikonu korisnika: koliko taskova ceka izvrsitelja.
             Kad ih nema, znacke nema - "v-badge" s value=false se ne crta. -->
        <v-btn
          text
          v-if="$store.state.isUserLoggedIn"
          @click="switchLog">
          <v-badge
            :value="taskCeka > 0"
            :content="taskCeka > 99 ? '99+' : taskCeka"
            color="red"
            overlap
            bordered
          >
            <v-icon color="#ffffff">mdi-account-circle-outline</v-icon>
          </v-badge>
        </v-btn>
        <!-- <v-btn
          text
          v-if="$store.state.isUserLoggedIn"
          @click="logout">
          Log Out
        </v-btn>      -->

       </v-toolbar-items>
    </v-app-bar>
    
    <v-main>
      <v-container fluid class="pt-0 pl-0 pr-1">
          <v-dialog
            v-model="showLogOut"
            max-width="560px"
            scrollable
          >
            <v-card>
              <v-card-title class="blue darken-4 white--text py-3">
                <v-icon color="white" class="mr-2">mdi-account-circle-outline</v-icon>
                <span class="subtitle-1">{{ $store.getters.NeedFullUser }}</span>
                <v-spacer></v-spacer>
                <v-btn icon dark @click="showLogOut = false">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-card-title>

              <v-card-text class="pt-4" style="max-height: 60vh">
                <!-- Taskovi koji cekaju izvrsitelja. Prije je ovo morao sam
                     traziti po ekranima, pa je sustav ostao nekoristen. -->
                <div class="d-flex align-center mb-2">
                  <span class="subtitle-2 grey--text text--darken-2">{{ taskNaslov }}</span>
                  <v-spacer></v-spacer>
                  <v-btn icon small :loading="taskUcitavam" @click="osvjeziTaskove">
                    <v-icon small>mdi-refresh</v-icon>
                  </v-btn>
                </div>

                <v-alert v-if="taskGreska" type="warning" dense text class="mb-2">
                  {{ taskGreska }}
                </v-alert>

                <div v-if="taskCeka === 0 && !taskUcitavam" class="text-center py-4 grey--text">
                  <v-icon large color="green">mdi-check-circle-outline</v-icon>
                  <div class="mt-1">{{ lang.TaskNemaZaMene }}</div>
                </div>

                <v-list v-else dense class="py-0">
                  <v-list-item
                    v-for="t in taskZadnji"
                    :key="t.id"
                    class="px-0 task-redak"
                  >
                    <v-list-item-content>
                      <v-list-item-title class="body-2">
                        {{ t.taskShortDescription || lang.TaskBezOpisa }}
                      </v-list-item-title>
                      <v-list-item-subtitle class="caption">
                        <span v-if="t.CompanyNameDatabase">{{ t.CompanyNameDatabase }}</span>
                        <span v-if="t.partnerName"> &middot; {{ t.partnerName }}</span>
                        <span v-if="t.taskForDate">
                          &middot;
                          <span :class="dospio(t.taskForDate) ? 'red--text font-weight-medium' : ''">
                            {{ localDate(t.taskForDate) }}
                          </span>
                        </span>
                      </v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-action class="my-0">
                      <v-btn
                        small
                        text
                        color="green darken-2"
                        :loading="taskZatvaram === t.id"
                        @click="obavljeno(t)"
                      >
                        {{ lang.TaskObavljeno }}
                      </v-btn>
                    </v-list-item-action>
                  </v-list-item>
                </v-list>

                <div v-if="taskCeka > taskZadnji.length" class="caption grey--text mt-1">
                  {{ lang.TaskJosIh }} {{ taskCeka - taskZadnji.length }}
                </div>

                <v-btn
                  v-if="taskCeka > 0"
                  text
                  small
                  color="primary"
                  class="mt-2 pl-0"
                  @click="otvoriMojeTaskove"
                >
                  {{ lang.TaskSviMoji }}
                  <v-icon small right>mdi-arrow-right</v-icon>
                </v-btn>

                <v-divider class="mt-4 mb-3"></v-divider>

                <v-btn color="primary" block @click="logout()">{{ lang.TaskOdjava }}</v-btn>
              </v-card-text>
            </v-card>
          </v-dialog>

          <router-view :key="$route.fullPath"></router-view>
      </v-container>
    </v-main>

    <v-footer :fixed="fixed" app>
      <span><v-btn text href="https://roboot.net" target="_blank" class="ma-0 pa-0">CE grupa</v-btn> &copy; 2026, v.1.0.19 </span><span v-if="$store.state.isUserLoggedIn">&nbsp;&nbsp;,{{ this.$store.getters.NeedFullUser }}</span><span v-if="$store.state.isUserLoggedIn">&nbsp;&nbsp;<v-btn text @click="langDetails">{{ this.$store.state.language }}</v-btn></span>
      <v-spacer></v-spacer>

    </v-footer>
  </v-app>
</template>

<script>
import langEn from './components/mainDescEN'
import langHr from './components/mainDescHR'
import commEn from '@/language/commonEN'
import commHr from '@/language/commonHR'
import AppNavigation from './AppNavigation'
import TaskService from '@/services/TaskService'
import dayjs from 'dayjs'

// Koliko se ceka prije ponovnog dohvata brojcica. Dvije minute: dovoljno da
// izvrsitelj vidi novi zadatak bez odgode koja se primijeti, a dovoljno rijetko
// da ne stvara promet dok nitko nista ne mijenja.
const OSVJEZI_SVAKIH = 120000

export default {
  name: 'App',
  components: {
      AppNavigation
  },
  data: () => ({
    clipped: false,
    drawer: true,
    fixed: false,
    miniVariant: false,
    right: true,
    rightDrawer: false,
    title: 'Roboot.net',
    mainDashboard: 'Dashboard',
    items: [],
    lang: {},
    langC: {},
    currentPath: '',
    joppd: 0,
    group: null,
    showLogOut: false,
    taskUcitavam: false,
    taskZatvaram: 0,
    taskGreska: '',
    taskSat: null
  }),
  beforeDestroy () {
    if (this.taskSat) { clearInterval(this.taskSat) }
  },
  mounted () {
    if (this.$store.state.language === 'EN') {
      this.lang = langEn
      this.langC = commEn
    }
    if (this.$store.state.language === 'HR') {
      this.lang = langHr
      this.langC = commHr
    }
    this.mainDashboard = this.lang.Dashboard
    this.$store.dispatch('setMenuShow', this.drawer)

    this.osvjeziTaskove()
    // Novi zadatak stize od drugog korisnika, pa ga nista na ovom ekranu ne
    // objavi - brojcic se zato osvjezava sam.
    this.taskSat = setInterval(() => {
      if (this.$store.state.isUserLoggedIn) { this.osvjeziTaskove() }
    }, OSVJEZI_SVAKIH)
  },
  computed: {
    taskCeka () {
      return this.$store.state.taskCekaBroj ? this.$store.state.taskCekaBroj : 0
    },
    taskZadnji () {
      return this.$store.state.taskCekaZadnji ? this.$store.state.taskCekaZadnji : []
    },
    taskNaslov () {
      const n = this.taskCeka
      return n > 0 ? this.lang.TaskCekaju + ' (' + n + ')' : this.lang.TaskCekaju
    },
    menuItems () {
      let menuItems = [
        // { icon: 'face', title: 'Login', link: '/users/login' },
        // { icon: 'face', title: 'Sign up', link: '/users/signup' },
    // ]
    // if (this.userIsAuthenticated ) {
    //   menuItems = [
        { icon: 'face', title: 'Radna ploča', link: '/crm/home' }
        // { icon: 'person', title: 'Sign Out', link: '/users/signout' }
      ]
      // }
      return menuItems
    },
    // userIsAuthenticated () {
        // return this.$store.getters.user !== null && this.$store.getters.user !== undefined
    // }
  },
  watch: {
    'drawer' () {
      this.$store.dispatch('setMenuShow', this.drawer)
    },
    // Nakon prijave korisnik je poznat tek sad, a tada brojcic ima smisla.
    '$store.state.isUserLoggedIn' (prijavljen) {
      if (prijavljen) { this.osvjeziTaskove() }
      else { this.$store.dispatch('setTaskCeka', {broj: 0, poFirmama: [], zadnji: []}) }
    },
    // Zadatak je mogao biti zadan ili zatvoren na ekranu koji smo upravo
    // napustili.
    '$route' () {
      if (this.$store.state.isUserLoggedIn) { this.osvjeziTaskove() }
    }
  },
  methods: {
    async osvjeziTaskove () {
      const UserId = this.$store.getters.NeedUserID
      if (!this.$store.state.isUserLoggedIn || !UserId) {
        this.$store.dispatch('setTaskCeka', {broj: 0, poFirmama: [], zadnji: []})
        return
      }
      try {
        this.taskUcitavam = true
        this.taskGreska = ''
        const {data} = await TaskService.taskceka({UserId: UserId})
        this.$store.dispatch('setTaskCeka', data)
      } catch (err) {
        // Brojcic nije vrijedan rusenja ekrana: ostaje zadnji poznati broj.
        // eslint-disable-next-line
        console.log('brojcic taskova:', err)
      } finally {
        this.taskUcitavam = false
      }
    },
    async obavljeno (task) {
      try {
        this.taskZatvaram = task.id
        this.taskGreska = ''
        const {data} = await TaskService.taskzatvori(task.id, {
          UserId: this.$store.getters.NeedUserID,
          email: this.$store.getters.NeedUseremail
        })
        // Posluzitelj vraca novi broj, ali popis treba ponovno - zato dohvat.
        if (data && typeof data.broj === 'number') {
          this.$store.dispatch('setTaskCeka', {
            broj: data.broj,
            poFirmama: this.$store.state.taskCekaPoFirmama,
            zadnji: this.taskZadnji.filter(x => x.id !== task.id)
          })
        }
        await this.osvjeziTaskove()
      } catch (err) {
        const odgovor = err && err.response && err.response.data
        this.taskGreska = odgovor && odgovor.error ? odgovor.error : 'Zadatak se nije mogao zatvoriti.'
      } finally {
        this.taskZatvaram = 0
      }
    },
    otvoriMojeTaskove () {
      this.showLogOut = false
      this.$router.push({name: 'task'}).catch(err => {
        // eslint-disable-next-line
        console.log(err)
      })
    },
    localDate (datum) {
      return datum ? dayjs(datum).format('DD.MM.YYYY') : ''
    },
    // Rok je danas ili je prosao - takav se u popisu pise crveno.
    dospio (datum) {
      return datum ? dayjs(datum).isBefore(dayjs().add(1, 'day'), 'day') : false
    },
    switchLog() {
      if (this.$store.state.isUserLoggedIn === true) {
        this.showLogOut = !this.showLogOut
        if (this.showLogOut) { this.osvjeziTaskove() }
      }
    },
    logout () {
      this.showLogOut = false
      this.$store.dispatch('setTaskCeka', {broj: 0, poFirmama: [], zadnji: []})
      this.$store.dispatch('setBusinessYear', null)
      this.$store.dispatch('setCompanyName', null)
      this.$store.dispatch('setCompanyid', null)
      this.$store.dispatch('setCompanyActiv', null)
      this.$store.dispatch('setToken', null)
      this.$store.dispatch('setUser', null)
      this.$store.dispatch('isUserLoggedIn', false)
      this.$store.dispatch('setDateItems', null)
      this.$store.dispatch('setDatePartners', null)
      this.$store.dispatch('setDateAccounts', null)
      this.$router.push({
        path: '/'
      }).catch(err => {
          // eslint-disable-next-line
          console.log(err);
        })
    },
    changeDrawer() {
      if (this.$store.state.isUserLoggedIn){
        this.drawer = !this.drawer
        console.log('Mijenjam drawer', this.drawer)
      }
    },
    login () {
      this.$router.push({
        path: '/'
      }).catch(err => {
          // eslint-disable-next-line
          console.log(err);
        })
    },
    userDetails () {
      if (this.$store.state.user) {
        // this.$store.dispatch('setUserid', this.$store.state.user.id)
        this.$router.push({
          name: 'userview'
        }).catch(err => {
          // eslint-disable-next-line
          console.log(err);
        })
      }
    },
 
    companyDetails () {
      if (this.$store.state.companyid) {
        this.$router.push({
          name: 'companyselect'
        }).catch(err => {
          // eslint-disable-next-line
          console.log(err);
        })
      }
    },
    companyDetails2 () {
      if (this.$store.state.companyid) {
        this.$router.push({
          name: 'companybusinessyearselect'
        }).catch(err => {
          // eslint-disable-next-line
          console.log(err);
        })
      }
    },
    langDetails () {
      if (this.$store.state.language) {
        this.$router.push({
          name: 'languageselect'
        }).catch(err => {
          // eslint-disable-next-line
          console.log(err);
        })
      }
    }
  }
};
</script>

<style scoped>
/* Redci u popisu zadataka: tanka crta izmedu, bez okvira oko svakog. */
.task-redak + .task-redak {
  border-top: 1px solid #eef1f4;
}
</style>